export default __webpack_public_path__ + "static/media/Parker.3eabe0d9.jpg";